export class MortalityConditionLevelOne {
    ID;
    ConditionName;
    constructor({id, conditionName}) {
        this.ID = id;
        this.ConditionName = conditionName;
    }
}